import React, { useState } from 'react';
import '../styles/Contact.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaClock, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();    
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Phone',
      info: '512-648-9102',
      link: 'tel:512-648-9102'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      info: 'M502ConstructionLLC@gmail.com',
      link: 'mailto:M502ConstructionLLC@gmail.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Address',
      info: '1812 Dara Lane, San Marcos, TX 78666',
      link: 'https://maps.google.com'
    },
   
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get Your Free Estimate</h2>
          <p className="section-subtitle">
            Contact us today to discuss your construction project
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Service</option>
                  <option value="masonry">Masonry</option>
                  <option value="concrete">Concrete</option>
                  <option value="stone-work">Stone Work</option>
                  <option value="brick">Brick</option>
                  <option value="block">Block</option>
                  <option value="landscaping">Landscaping</option>
                  <option value="tree-services">Tree Services</option>
                  <option value="fence">Fence</option>
                  <option value="junk-removal">Junk Removal</option>
                  <option value="custom-blower-beds">Custom Blower Beds</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Tell us about your project"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-block">
                Get Free Estimate
              </button>
            </form>
          </div>

          <div className="contact-info-container">
            <div className="contact-info-card">
              <h3>Contact Information</h3>
              <p className="contact-tagline">
                <strong>Strong foundations, stronger trust.</strong>
              </p>
              
              <div className="contact-details">
                {contactInfo.map((item, index) => (
                  <a key={index} href={item.link} className="contact-item">
                    <div className="contact-icon">{item.icon}</div>
                    <div className="contact-text">
                      <span className="contact-label">{item.title}</span>
                      <span className="contact-value">{item.info}</span>
                    </div>
                  </a>
                ))}
              </div>

              <div className="business-hours">
                <h4><FaClock /> Business Hours</h4>
                <p>Monday - Friday: 7:00 AM - 6:00 PM</p>
                <p>Saturday: 8:00 AM - 4:00 PM</p>
                <p>Sunday: Closed</p>
              </div>

              <div className="quick-contact">
                <p>Need immediate assistance?</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;